import { getStyleFile } from './get-style-file'
import { importStyles } from './import-styles'
import { appendStyleToBody } from './append-style-to-body'
import {
  activeVariantConfig,
  logger,
  SERVICE,
  TEAM,
} from '@otto-ec/eprivacy-shared'
import {
  createMeasureServiceFor,
  MeasureType,
  Result,
} from '@otto-ec/eprivacy-measures'

/**
 *
 *
 *
 */
export async function initStyles() {
  try {
    const initMeasureService = createMeasureServiceFor(
      MeasureType.Init,
      TEAM,
      SERVICE
    )
    await initMeasureService.runLoadStyles(
      async () => {
        const onexConfig = await activeVariantConfig()
        const stylesScss = getStyleFile(onexConfig)
        const styleCode = await importStyles(stylesScss)
        appendStyleToBody(styleCode)
      },
      { successResult: Result.Success, failureResult: Result.Failure }
    )
  } catch (error) {
    logger.error(new Error('Could not load styles', { cause: error }))
  }
}
